export default __webpack_public_path__ + "static/media/KK_E_Left_Top_aCrop.8018ac4c.svg";